import { gql } from "@apollo/client";

export const GET_ESTADOS_LOGISTICA = gql`
    query AllEstadoLogistica{
        allEstadoLogistica{
            idGestionLogisticaEstado
            descripcion
        }
    }
`;